import React, {
    PureComponent
  }                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
  }                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import styles                 from './style'
import moment from 'moment';

class AddEvent extends PureComponent{
    static PropTypes = {
        actions: PropTypes.shape({
            enterPage: PropTypes.func,
            leavePage: PropTypes.func,
        })
    };

    constructor(props){
        super(props);
        this.state = {
            venues: [],
            game_types: [],
            age_categories: [],
            event_details: {
                venue: '',
                name: '',
                game_type: '',
                age_categories: '',
                start_date: '',
                registration_end: '',
                banner: '',
                mobile_no:'',
                description: '',
                registration_amount: '',
                
            },
            search:false,
            details:'',
            mobile_no:'',
            buddy_search_list:[],
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleStartDateChange = this.handleStartDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleFile = this.handleFile.bind(this);
        this.getSearchList = this.getSearchList.bind(this);
        this.setSearch = this.setSearch.bind(this);
    }

    componentDidMount() {
        this.getEventDetails();
        console.log(this.state);
    }
    getSearchList() {
        var mobile_no = this.state.mobile_no
        const url = `${getLocationOrigin()}/eagleeye/search_buddy/`;
        const options = {...defaultOptions};
        options['method'] = 'post';
        options['headers'] = {'content-type': 'application/json'}
        options['body'] = JSON.stringify({
                             'search': mobile_no
                           });
        return fetch(url, options)
           .then(checkStatus)
           .then(parseJSON)
           .then(data => this.setState({buddy_search_list: data.results, search: true}))
           .catch(error => {
             console.log(error);
             alert(error.message);
           });
    }
    setSearch(name, buddy_id, mobile_no){
        var new_selected_one =  Object.assign({}, this.state.event_details);
        new_selected_one['buddy_id'] = buddy_id
        this.setState({event_details: new_selected_one, search: false,mobile_no:name});

    }

    getEventDetails() {
        const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_event/`;
        const options = {...defaultOptions};
   
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            this.setState(
            { venues: data.venues,
              game_types: data.game_types,
              age_categories: data.age_categories
            });
           })
          .catch(error => error);
    }

    postaddEvent(data, props) {
        if(!data.venue){data.venue=this.state.venues[0].id}
        if(!data.game_type){data.game_type=this.state.game_types[0].pk}
        if(!data.age_categories){data.age_categories=this.state.age_categories[0].id}
        console.log(data);
        const url = `${getLocationOrigin()}/eagleeye/add_event/`;
        const options = {...defaultOptions};
        var formData = new FormData();
        for(var name in data) {
          formData.append(name, data[name]);
        }
        for(var start_date in data){
            formData.append(start_date, data[start_date]);
        }
        for(var registration_end in data){
            formData.append(registration_end, data[registration_end]);
        }
        options['method'] = 'post';
        options['body'] = formData;
        console.log('Going to fetch');
        return fetch(url, options)
            .then(checkStatus)
            .then(parseJSON)
            .then(function(response){                      // first then()
                alert(response.message);
                props.history.goBack();
                })
            .catch(error => {
                console.log(error);
                alert(error.message);
            });
      }
   

    handleChange(event) {
        console.log(event.target.value)
        const name = event.target.name;
        if(name== 'mobile_no'){
            this.setState({mobile_no:event.target.value})
        }
        else{
        const name = event.target.name;
        var new_value =  Object.assign({}, this.state.event_details);
        new_value[name] = event.target.value
        this.setState({event_details: new_value});
        }

    }

    handleStartDateChange(event){
        const start_date = event.target.name
        var new_value = Object.assign({}, this.state.event_details);
        new_value[start_date] = event.target.value
        this.setState({event_details: new_value});
    }
    handleEndDateChange(event){
        const registration_end = event.target.name;
        var new_value = Object.assign({}, this.state.event_details);
        new_value[registration_end] = event.target.value
        this.setState({event_details: new_value})

    }
    handleFile(selectorFiles: FileList){
        var new_value =  Object.assign({}, this.state.event_details);
        console.log('Fileeeee');
        console.log(selectorFiles);
        new_value['banner'] = selectorFiles[0]
        this.setState({event_details: new_value});
      }

    handleSubmit(){
        event.preventDefault();
        console.log('Event_Details');
        console.log(this.state.event_details);
        this.postaddEvent(this.state.event_details, this.props);
        console.log('post');
        console.log(this.state);
    }
    render(){
        console.log(this.state)
        return(
        <div style={styles.container}>
            <div className="row col-md-8 table-bordered" style={styles.table}>
                <div style={styles.main_header} >
                    <h3 style={{textAlign:'center'}}>Add Event</h3>
                </div>
                <form className="validated-form form-horizontal" onSubmit={this.handleSubmit}>
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Event Name
                    </div>
                    <input type="text" style={styles.input} name="name" className="required"
                        value={this.state.value} onChange={this.handleChange}/>    
                </div>
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Venue
                    </div>
                    <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.venues.map((venue, index) => (
                        <option key={venue.id} value={venue.id}>{venue.name}</option>
                        ))
                        }
                    </select>
                </div>
                <div className="col-md-12" style={{'marginTop':"10px"}}>
                        <div style={styles.item_header} className="col-md-6">
                            Coordinator
                        </div>
                        <div className="col-md-6 input-group">
                                <input type="text" name="mobile_no" className="form-control" 
                                placeholder="Search for.. " value={this.state.mobile_no} onChange={this.handleChange}/>
                                <span className="input-group-btn">
                                <button className="btn btn-default glyphicon glyphicon-search"
                                type="button" onClick={this.getSearchList}></button>
                                </span>
                         </div>
                    </div>
                        {this.state.search?
                            <div className="col-md-12 btn-group">
                                {this.state.buddy_search_list.length?this.state.buddy_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
                            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
                            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
                            <div className="alert alert-danger">Search customer not found</div>
                            <div>
                            <RaisedButton
                            onClick={this.handleOpen}
                            label="Add"
                            style={{float:'right'}}
                            secondary={true}
                            />
                            <Dialog
                            actions={actions}
                            modal={false}
                            open={this.state.dialog_open_cust}
                            onRequestClose={this.handleClose}
                            >
                            <div>
                                <div style={styles.main_header} className="col-md-12">
                                <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                                </div>
                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Name
                                </div>
                                <input type="text" style={styles.input} name="cust_name" className="required"
                                    value={this.state.value} onChange={this.handleChange}/>
                                </div>

                                <div style={styles.items} className="col-md-12">
                                <div style={styles.item_header} className="col-md-6">
                                    Mobile No
                                </div>
                                <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                                    value={this.state.mobile_no} onChange={this.handleChange}/>
                                </div>
                            </div>
                            </Dialog>
                        </div>
                        </div>
                    }</div>:''}
                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Game Type
                    </div>
                    <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.game_types.map((game_type, index) => (
                        <option key={game_type.pk} value={game_type.pk}>{game_type.game +'-'+ game_type.name}</option>
                        ))
                        }
                    </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Age Category
                    </div>
                    <select name="age_categories" className="col-md-6" style={styles.item_body} value={this.state.value}
                        onChange={this.handleChange}>
                        <option key={-1} value={""} defaultValue={true}> {"-----------------"}</option>
                        {
                        this.state.age_categories.map((age_category, index) => (
                        <option key={age_category.id} value={age_category.id}>{age_category.name}</option>
                        ))
                        }
                    </select>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Banner
                    </div>
                    <input type="file" style={styles.input} style={{float:'left'}} name="banner" onChange={ (e) => this.handleFile(e.target.files) }/>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Start Date(DD/MM/YYYY)
                    </div>
                    <input type='text' style={styles.input} name="start_date" value={this.state.value} onChange={this.handleStartDateChange}/>
                    
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                     Registration End Date(DD/MM/YYYY)
                    </div>
                    <input type='text' style={styles.input} name="registration_end" value={this.state.value} onChange={this.handleEndDateChange}/>
                    
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Description
                    </div>
                    <textarea rows="4" cols="33" style={styles.input} id="description" name="description" placeholder="Description"
                        onChange={this.handleChange}>
                        {this.state.event_details.description}
                    </textarea>
                </div>

                <div style={styles.items} className="col-md-12">
                    <div style={styles.item_header} className="col-md-6">
                        Registration Amount
                    </div>
                    <input type="number" style={styles.input} name="registration_amount" className="required"
                        value={this.state.value} onChange={this.handleChange}/>
                </div>

                <div style={styles.button_submit} className="col-md-12">
                    <input className="btn btn-lg" type="submit" value="Submit" style={{backgroundColor:'#302C35',
                        color:'#ffffff'}}/>
                </div>
                
                </form>
            </div>
        </div>    
        );
    }
}

export default AddEvent;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addEvent/index.js